import { useMemo } from 'react';
import type { OperationsDashboardSnapshot } from '@tcvs/shared';
import { useApi } from '../api';
import type { ApiResult } from '../auth/api-client';

export function useOperationsApi() {
  const api = useApi();
  return useMemo(
    () => ({
      summary: (devDiagnostics = false): Promise<ApiResult<OperationsDashboardSnapshot>> =>
        api.request<OperationsDashboardSnapshot>(
          `/dashboard/summary?view=operations${devDiagnostics ? '&diagnostics=dev' : ''}`,
          {
            method: 'GET',
          },
        ),
    }),
    [api],
  );
}
